import Vue from 'vue';
import guide from 'vue-xpc/src/components/guide';
import { isObject } from '../utils/types';

function sLookup (url) {
  var l = (screen.availWidth - 560) / 2;
  var t = (screen.availHeight - 614) / 2;

  window.open(
    url,
    '_blank',
    'width=560,height=614,top=' +
      t +
      ',left=' +
      l +
      ',toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no'
  );
}

function editWindow (url) {
  var l = (screen.availWidth - 1440) / 2;
  var t = (screen.availHeight - 900) / 2;

  window.open(
    url,
    '_blank',
    'width=1440,height=900,top=' +
      t +
      ',left=' +
      l +
      ',toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no'
  );
}

function showAlertDialog (title, content, options) {
  return Vue.prototype.$alert(content, title, options);
}

function alert (content, callback) {
  showAlertDialog(Vue.prototype.$tx('提示', 'xpc.common.hint'), content, {
    callback: callback
  });
}

function confirm (content, options = {}) {
  return showConfirmDialog(
    '',
    content,
    Vue.prototype.$tx('确定', 'xpc.common.ok'),
    Vue.prototype.$tx('取消', 'xpc.common.cancel'),
    'info'
  );
}

function showConfirmDialog (
  title,
  content,
  confirmButtonContent,
  cancelButtonContent,
  confirmType
) {
  return Vue.prototype.$confirm(content, title, {
    confirmButtonText: confirmButtonContent,
    cancelButtonText: cancelButtonContent,
    type: confirmType
  });
}

let loading = null;
function showLoadingToast (content, options = {}) {
  options.text = typeof content === 'string' ? content : '';
  if (typeof content === 'object') {
    options = content;
  }
  options.size = options.size || 'large';
  options.textColor = options.textColor || 'neutralRegular';
  options.background = options.background || 'rgba(255,255,255,0)';
  options.type = options.type || 1;
  options.hiddenMask = options.hiddenMask || false;
  options.fullscreen = options.fullscreen === undefined ? true : options.fullscreen;
  if (!loading) {
    loading = Vue.prototype.$loading(options);
  }
}

function hideLoadingToast () {
  loading && loading.close();
  loading = null;
}

function showErrorToast (error = '', isClose = true) {
  if (rt.isNil(error)) return;
  const message = isObject(error) ? error.message : error;
  const showClose = isObject(error) ? error.showClose : isClose;

  if (rt.isNil(message) || !String(message).trim().length || message === 'Request aborted') {
    // 报错信息为空或者连接中断的情况下,不抛错
    return;
  }
  Vue.prototype.$message({
    ...error,
    showClose,
    message,
    dangerouslyUseHTMLString: false,
    type: 'error',
    wrapperClass: '.app-body'
  });
}

function showSuccessToast (content, isClose = true) {
  if (rt.isNil(content)) return;
  const message = isObject(content) ? content.message : content;
  const showClose = isObject(content) ? content.showClose : isClose;

  Vue.prototype.$message({
    ...content,
    showClose,
    message,
    dangerouslyUseHTMLString: false,
    type: 'success',
    wrapperClass: '.app-body'
  });
}

const isImageFile = fileType =>
  ['bmp', 'jpg', 'jpeg', 'png', 'gif'].includes(fileType.toLowerCase());

const isHeicFile = fileType => ['heic'].includes(fileType.toLowerCase());

const isWordFile = fileType =>
  ['doc', 'docx', 'wps', 'dot', 'dot', 'dotx', 'docm', 'dotm'].includes(
    fileType.toLowerCase()
  );

const isPdfFile = fileType => ['pdf'].includes(fileType.toLowerCase());

const isPptFile = fileType =>
  ['ppt', 'pptx', 'pps', 'ppsx', 'pot', 'ppa'].includes(fileType.toLowerCase());

const isZipFile = fileType =>
  ['zip', 'rar', '7z', 'ar', 'bz', 'car', 'dar', 'cpgz', 'f', 'ha'].includes(
    fileType.toLowerCase()
  );

const isTxtFile = fileType => ['txt'].includes(fileType.toLowerCase());

const isExcelFile = fileType =>
  ['xls', 'xlsx', 'csv'].includes(fileType.toLowerCase());

const isVideoFile = fileType =>
  [
    'mp4',
    'wmv',
    'asf',
    'asx',
    'rm',
    'rmvb',
    'mov',
    'm4v',
    'avi',
    'dat',
    'mkv',
    'flv',
    'vob',
    '3gp'
  ].includes(fileType.toLowerCase());

const isMusicFile = fileType =>
  [
    'wav',
    'flac',
    'ape',
    'alac',
    'wavpack',
    'mp3',
    'aac',
    'ogg',
    'opus'
  ].includes(fileType.toLowerCase());

/**
 * 根据文件后缀获取相应的图标信息
 * @param {*} fileType
 * @returns
 */
function getFileIconInfo (fileType = '') {
  if (isImageFile(fileType)) {
    return;
  }

  if (isHeicFile(fileType)) {
    return { iconName: 'rt-base-file-image-filled', iconColor: 'primary' };
  }

  if (isWordFile(fileType)) {
    return { iconName: 'rt-base-file-word-filled', iconColor: 'primary' };
  }

  if (isPdfFile(fileType)) {
    return { iconName: 'rt-base-file-pdf-filled', iconColor: 'danger' };
  }

  if (isPptFile(fileType)) {
    return { iconName: 'rt-base-file-ppt-filled', iconColor: 'warning' };
  }

  if (isZipFile(fileType)) {
    return { iconName: 'rt-base-file-zip-filled', iconColor: 'warning' };
  }

  if (isTxtFile(fileType)) {
    return { iconName: 'rt-base-file-txt-filled', iconColor: 'primary' };
  }

  if (isVideoFile(fileType)) {
    return { iconName: 'rt-base-file-video-filled', iconColor: 'success' };
  }

  if (isExcelFile(fileType)) {
    return { iconName: 'rt-base-file-excel-filled', iconColor: 'success' };
  }

  if (isMusicFile(fileType)) {
    return { iconName: 'rt-base-file-music-filled', iconColor: 'success' };
  }

  return { iconName: 'rt-base-file-unknown-filled', iconColor: 'info' };
}

function showGuide (options) {
  guide(options);
}

export {
  sLookup,
  editWindow,
  showAlertDialog,
  alert,
  confirm,
  showConfirmDialog,
  showSuccessToast,
  showErrorToast,
  showLoadingToast,
  hideLoadingToast,
  isImageFile,
  isHeicFile,
  isWordFile,
  isPdfFile,
  isPptFile,
  isZipFile,
  isTxtFile,
  isVideoFile,
  isExcelFile,
  isMusicFile,
  getFileIconInfo,
  showGuide
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/ui.js